import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetFjPublicJobQuery } from '../../../../redux/services/fj_jobs.jsx';
import { MainTitle, Spinner } from '../../../common/index.jsx';
import FjJobDetail from '../../../common/FriJobs/FjJobDetail.jsx';
import useScrollToTopOnMount from '../../../../hooks/useScrollToTopOnMount.jsx';

const FjJobsDetailPage = () => {
  useScrollToTopOnMount();
  const { t } = useTranslation();
  const { id } = useParams();
  const { data: job, isLoading, refetch } = useGetFjPublicJobQuery(id);

  useEffect(() => {
    document.title = t('FRI.jobs - detail pracovnej ponuky');
  }, []); // Runs on mount

  return (
    <>
      <MainTitle title={`${t('Detail pracovnej ponuky')}`} backAction={true} />

      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <FjJobDetail jobData={job} />
        </>
      )}
    </>
  );
};

export default FjJobsDetailPage;
